import React, {} from 'react';
const styles = {"footer":"SiteFooter-module__footer__MXa59"};
/** The site page's last line: small, centered and muted, such as "© 2026 Naru". */
export function SiteFooter({ children }) {
    return React.createElement("footer", { className: styles.footer }, children);
}
//# sourceMappingURL=SiteFooter.js.map